// extracted by mini-css-extract-plugin
module.exports = {"sectionTitleWrapper":"SectionTitle_sectionTitleWrapper__GA_pN","root":"SectionTitle_root__X8q_M","divider":"SectionTitle_divider__YLM6T"};